module.exports = " <div> <div v-for=\"men in mens\" track-by=$index v-bind:key=men._id> <span style=\"font-size: medium\" v-if=\"men.type==='text'\"><b> {{ men.send }} :</b> {{ men.body }}</span> <span class=right style=\"font-size: small; color:#aaa\">{{ men.created | moment 'h:mm:ss'}}</span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/home/bodyMen.vue
// module id = 493
// module chunks = 10